import React, { Component } from "react";
import "rc-collapse/assets/index.css";
import { ValidarCNPJ, ValidarCep } from "../../utils/Validar";
import {
  FormControl,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Image,
  FormLabel,
} from "react-bootstrap";
import {
  ListarEstabelecimentos,
  EditarEstabelecimento,
  DeletarEstabelecimento,
  CadastrarEstabelecimento,
  MudarStatusEstabelecimento,
  MudarStatusEntrega,
  MudarStatusDestaque,
  MudarStatusEstabelecimentoModelo,
} from "../../providers/EstabelecimentoProvider";
import { getCEP, getCoordenadas } from "../../providers/AdminProvider";
import TBLEstabelecimento from "../../components/TBLEstabelecimentos";
import { api_url_estabelecimentos_image } from "../../providers/api";
import Select from "react-select";
import InputMask from "react-input-mask";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import { toast } from "react-toastify";
import { BuscarEstabelecimentoPorNome } from "../../providers/BuscaProvider";
import { ListarTipoEstabelecimento } from "../../providers/TiposEstabelecimentoProvider";
import Switch from "../../components/Switch";

export default class Estabelecimentos extends Component {
  constructor(props) {
    super(props);

    this.mapRef = React.createRef();

    this.state = {
      tiposEstabelecimento: {},
      estabelecimentos: [],
      estabelecimentoSelecionado: null,
      center: [-5.8296303, -35.2113399],
      zoom: 14,
      hasLocation: false,
      edited: false,
      pages: 1,
      page: 1,
      limit: 10,
      loading: false,
      validarCep: false,
      validarCNPJ: false,
      error: {
        nome_social: "",
        nome_fantasia: "",
        cnpj: "",
        telefone: "",
        inscricao_estadual: "",
        area_atuacao: "",
        tipo: "",
        endereco: {
          rua: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          pais: "Brasil",
          latitude: "",
          longitude: "",
          cep: "",
        },
        imagem: null,
        usuario: {
          email: "",
          senha: "",
        },
      },
      form: {
        nome_social: "",
        nome_fantasia: "",
        cnpj: "",
        telefone: "",
        inscricao_estadual: "",
        area_atuacao: "",
        tipo: "",
        endereco: {
          rua: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          pais: "Brasil",
          latitude: "",
          longitude: "",
          cep: "",
        },
        imagem: null,
        usuario: {
          email: "",
          senha: "",
        },
      },
      foto_estabelecimento: null,
      errorSenha: "",
      confirmaSenha: "",
      showModalEstabelecimento: false,
      showModalAlert: false,
      showModalSenha: false,
      errorCadastro: "",
      modoEditarEstabelecimento: false,
      modoVisualizarEstabelecimento: false,
      showAlert: false,
      mensagemAlert: "",
      variantAlert: "",
      statusAtualEstabelecimentoSelecionado: null,
      statusEntregaEstabelecimento: false,
      statusEstabelecimentoDestaque: false,
      statusEstabelecimentoModelo: false,
      porcentagemTaxaServico: null,
      valorPedidoMinimo: null,
      emissaoDavDisponivel: false,
      congelamentoPrecoAtivo: false,
    };

    this.fileInput = null;
  }

  handleCloseModalEstabelecimento = () => {
    this.setState({ showModalEstabelecimento: false });
    this.limparForm();
  };

  handleShowModalEstabelecimento = () => {
    this.setState({ showModalEstabelecimento: true });
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = () => {
    this.setState({ showModalAlert: true });
  };
  handleShowModalSenha = () => {
    this.setState({ showModalSenha: true });
  };
  handleCloseModalSenha = () => {
    this.setState({ showModalSenha: false });
  };

  fileChangedHandler = (event) => {
    this.setState({
      form: { ...this.state.form, imagem: event.target.files[0] },
    });
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else if (variant === "error") {
      toast.error(mensagem);
    } else {
      toast.info(mensagem);
    }
  };

  validarForm = (form, isCadastro) => {
    let isValid = true;
    let error = this.state.error;
    const nao_obrigatorios = ["inscricao_estadual", "area_atuacao"];
    for (let key in form) {
      if (key === "endereco") {
        for (let j in form[key]) {
          if (form[key][j] === "" || form[key][j] === null) {
            error = {
              ...error,
              [key]: {
                ...error[key],
                [j]: `Campo ${j} obrigatório`,
              },
            };
            isValid = false;
          } else if (j === "cep" && !this.state.validarCep) {
            error = {
              ...error,
              [key]: {
                ...error[key],
                [j]: "CEP inválido",
              },
            };
            isValid = false;
          } else {
            error = {
              ...error,
              [key]: {
                ...error[key],
                [j]: "",
              },
            };
          }
        }
      } else if (key === "usuario") {
        for (let j in form[key]) {
          if (isCadastro) {
            if (form[key][j] === "" || form[key][j] === null) {
              error = {
                ...error,
                [key]: {
                  ...error[key],
                  [j]: `Campo ${j} obrigatório`,
                },
              };
              isValid = false;
            } else {
              error = {
                ...error,
                [key]: {
                  ...error[key],
                  [j]: "",
                },
              };
            }
          } else {
            if ((form[key][j] === "" || form[key][j] === null) && j !== "senha") {
              error = {
                ...error,
                [key]: {
                  ...error[key],
                  [j]: `Campo ${j} obrigatório`,
                },
              };
              isValid = false;
            } else {
              error = {
                ...error,
                [key]: {
                  ...error[key],
                  [j]: "",
                },
              };
            }
          }
        }
      } else {
        if ((form[key] === "" || form[key] === null) && !nao_obrigatorios.includes(key)) {
          error = {
            ...error,
            [key]: `Campo ${key} obrigatório`,
          };
          isValid = false;
        } else if (key === "cnpj" && !this.state.validarCNPJ) {
          error = {
            ...error,
            [key]: "CNPJ inválido",
          };
          isValid = false;
        } else {
          error = {
            ...error,
            [key]: "",
          };
        }
      }
    }
    this.setState({ error });
    return isValid;
  };

  confirmaSenha = () => {
    if (
      this.state.form.usuario.senha === this.state.confirmaSenha &&
      this.state.confirmaSenha !== ""
    ) {
      this.setState({ errorSenha: "Senha atualizada com sucesso" });
      setTimeout(() => {
        this.editarEstabelecimento();
        this.handleCloseModalSenha();
      }, 1000);
    } else {
      this.setState({ errorSenha: "Senhas não coincidem *" });
    }
  };
  limparForm = () => {
    this.setState({
      center: [-5.8296303, -35.2113399],
      zoom: 14,
      hasLocation: false,
      estabelecimentoSelecionado: null,
      pages: 1,
      page: 1,
      limit: 10,
      loading: false,
      validarCep: false,
      validarCNPJ: false,
      error: {
        nome_social: "",
        nome_fantasia: "",
        cnpj: "",
        telefone: "",
        inscricao_estadual: "",
        area_atuacao: "",
        tipo: "",
        endereco: {
          rua: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          pais: "Brasil",
          latitude: "",
          longitude: "",
          cep: "",
        },
        imagem: null,
        usuario: {
          email: "",
          senha: "",
        },
      },
      form: {
        nome_social: "",
        nome_fantasia: "",
        cnpj: "",
        telefone: "",
        inscricao_estadual: "",
        area_atuacao: "",
        tipo: "",
        endereco: {
          rua: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          pais: "Brasil",
          latitude: "",
          longitude: "",
          cep: "",
        },
        imagem: null,
        usuario: {
          email: "",
          senha: "",
        },
      },
      showModalEstabelecimento: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarEstabelecimento: false,
      modoVisualizarEstabelecimento: false,
      showAlert: false,
      mensagemAlert: "",
      variantAlert: "",
      porcentagemTaxaServico: null,
      valorPedidoMinimo: null,
      emissaoDavDisponivel: false,
      congelamentoPrecoAtivo: false,
    });
    this.fileInput ? (this.fileInput.value = "") : (this.fileInput = null);
  };

  atualizarMapa = async (endereco) => {
    let isComplete = true;
    for (let key in endereco) {
      if (
        (endereco[key] === "" || endereco[key] === null) &&
        key !== "latitude" &&
        key !== "longitude"
      ) {
        isComplete = false;
      }
    }
    if (isComplete && this.state.edited === false) {
      this.setState({ edited: true });
      const dados = await getCoordenadas(endereco);
      this.setState({
        center: [dados[0].geometry.location.lat, dados[0].geometry.location.lng],
        hasLocation: true,
        form: {
          ...this.state.form,
          endereco: {
            ...this.state.form.endereco,
            latitude: dados[0].geometry.location.lat,
            longitude: dados[0].geometry.location.lng,
          },
        },
      });
    }
  };

  mudarStatus = async (status) => {
    const res = await MudarStatusEstabelecimento(
      status ? "Aberto" : "Fechado",
      this.state.estabelecimentoSelecionado,
    );
    await this.getEstabelecimentos();
    this.setState({
      statusAtualEstabelecimentoSelecionado: status,
    });
  };

  mudarStatusEntrega = async (status) => {
    await MudarStatusEntrega(
      status ? true : false,
      this.state.estabelecimentoSelecionado,
    );
    await this.getEstabelecimentos();

    this.setState({
      statusEntregaEstabelecimento: status,
    });
  };

  mudarStatusDestaque = async (status) => {
    await MudarStatusDestaque(
      status ? true : false,
      this.state.estabelecimentoSelecionado,
    );
    await this.getEstabelecimentos();
    this.setState({
      statusEstabelecimentoDestaque: status,
    });
  };

  mudarStatusEstabelecimentoModelo = async (status) => {
    await MudarStatusEstabelecimentoModelo(
      status ? true : false,
      this.state.estabelecimentoSelecionado,
    );
    await this.getEstabelecimentos();
    this.setState({
      statusEstabelecimentoModelo: status,
    });
  };

  pesquisarEstabelecimento = async (value) => {
    if (value === "") {
      await this.getEstabelecimentos();
    } else {
      const response = await BuscarEstabelecimentoPorNome(value);
      this.setState({ estabelecimentos: response });
    }
  };

  pesquisarCEP = async (cep) => {
    if (cep) {
      try {
        const res = await getCEP(cep);
        if (res.erro) {
          this.setState({ validarCep: false });
        } else {
          this.setState({
            form: {
              ...this.state.form,
              endereco: {
                ...this.state.form.endereco,
                rua: res.logradouro,
                bairro: res.bairro,
                cidade: res.localidade,
                estado: res.uf,
                cep: cep,
                pais: "Brasil",
              },
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  preencherFormEdit = async (dados) => {
    const dado = this.state.tiposEstabelecimento;
    let tipo_label;
    let tipo_value;
    dado.forEach((item) => {
      if (item.value === dados.tipo._id) {
        tipo_label = item.label;
        tipo_value = item.value;
      }
    });
    this.setState({
      estabelecimentoSelecionado: dados,
      statusAtualEstabelecimentoSelecionado: dados.status === "Aberto",
      statusEstabelecimentoDestaque: dados.estabelecimento_destaque,
      statusEstabelecimentoModelo: dados.estabelecimento_modelo,
      validarCNPJ: true,
      validarCep: true,
      form: {
        nome_social: dados.nome_social,
        nome_fantasia: dados.nome_fantasia,
        cnpj: dados.cnpj,
        telefone: dados.telefone,
        inscricao_estadual: dados.inscricao_estadual,
        area_atuacao: dados.area_atuacao,
        tipo: {
          value: tipo_value,
          label: tipo_label,
        },
        endereco: {
          rua: dados.endereco.rua,
          numero: dados.endereco.numero,
          bairro: dados.endereco.bairro,
          cidade: dados.endereco.cidade,
          estado: dados.endereco.estado,
          pais: dados.endereco.pais,
          latitude: dados.endereco.latitude,
          longitude: dados.endereco.longitude,
          cep: dados.endereco.cep,
        },
        usuario: {
          email: dados.usuario.email,
          senha: "",
        },
      },
      porcentagemTaxaServico: dados.porcentagem_taxa_servico,
      valorPedidoMinimo: dados.valor_minimo_pedido,
      foto_estabelecimento: dados.foto_estabelecimento,
      modoEditarEstabelecimento: true,
      modoVisualizarEstabelecimento: true,
      emissaoDavDisponivel: dados.emissaoDavDisponivel,
      congelamentoPrecoAtivo: dados.congelamento_preco_ativo,
    });
    this.handleShowModalEstabelecimento();
  };

  editarEstabelecimento = async () => {
    let form = new FormData();
    let formEndereco = {};
    let formUsuario = {};

    if (!this.validarForm(this.state.form, false)) {
      this.setState({ errorCadastro: "Informações obrigatórias (*) faltando" });
      this.goTop();
      return;
    } else {
      form.append("nome_social", this.state.form.nome_social);
      form.append("nome_fantasia", this.state.form.nome_fantasia);
      form.append("cnpj", this.state.form.cnpj);
      form.append("telefone", this.state.form.telefone);
      form.append("inscricao_estadual", this.state.form.inscricao_estadual);
      form.append("area_atuacao", this.state.form.area_atuacao);
      form.append("tipo", this.state.form.tipo.value);
      form.append("valor_minimo_pedido", this.state.valorPedidoMinimo);
      form.append("porcentagem_taxa_servico", this.state.porcentagemTaxaServico);
      form.append("emissaoDavDisponivel", this.state.emissaoDavDisponivel);
      form.append("congelamento_preco_ativo", this.state.congelamentoPrecoAtivo);
      if (this.state.form.imagem) {
        form.append("imagem", this.state.form.imagem);
      }

      formEndereco = {
        rua: this.state.form.endereco.rua,
        numero: this.state.form.endereco.numero,
        bairro: this.state.form.endereco.bairro,
        cidade: this.state.form.endereco.cidade,
        estado: this.state.form.endereco.estado,
        pais: this.state.form.endereco.pais,
        latitude: this.state.form.endereco.latitude,
        longitude: this.state.form.endereco.longitude,
        cep: this.state.form.endereco.cep,
      };

      formUsuario = {
        email: this.state.form.usuario.email,
        senha:
          this.state.form.usuario.senha !== ""
            ? this.state.form.usuario.senha
            : undefined,
      };
    }
    try {
      const response = await EditarEstabelecimento(
        form,
        formEndereco,
        formUsuario,
        this.state.estabelecimentoSelecionado,
      );

      if (response) {
        this.limparForm();
        await this.getEstabelecimentos();
        await this.ListarTiposEstabelecimento();
        this.handleShowAlert("Estabelecimento editado com sucesso", "success");
      }
    } catch (error) {
      this.handleShowAlert(error.error, "error");
    }
  };

  deletarEstabelecimento = async () => {
    try {
      const response = await DeletarEstabelecimento(
        this.state.estabelecimentoSelecionado,
      );
      if (response) {
        this.limparForm();
        await this.getEstabelecimentos(1);
        this.handleShowAlert("Estabelecimento excluido com sucesso", "secondary");
      }
    } catch (error) {
      this.handleShowAlert(error.error, "error");
    }
  };
  getEstabelecimentos = async (current_page) => {
    this.setState({ loading: true });
    const { docs, limit, page, pages } = await ListarEstabelecimentos(current_page);
    if (docs) {
      this.setState({
        estabelecimentos: docs,
        pages,
        page,
        loading: false,
        limit,
      });
    }
  };

  goTop = () => {
    document
      .getElementById("modal-estabelecimento")
      .scrollIntoView({ behavior: "smooth" });
  };

  cadastrarEstabelecimento = async () => {
    let form = new FormData();
    let formEndereco = {};
    let formUsuario = {};
    if (this.validarForm(this.state.form, true)) {
      form.append("nome_social", this.state.form.nome_social);
      form.append("nome_fantasia", this.state.form.nome_fantasia);
      form.append("cnpj", this.state.form.cnpj);
      form.append("telefone", this.state.form.telefone);
      form.append("inscricao_estadual", this.state.form.inscricao_estadual);
      form.append("area_atuacao", this.state.form.area_atuacao);
      form.append("tipo", this.state.form.tipo.value);
      form.append("imagem", this.state.form.imagem);
      form.append("valor_minimo_pedido", this.state.valorPedidoMinimo);
      form.append("porcentagem_taxa_servico", this.state.porcentagemTaxaServico);
      form.append("emissaoDavDisponivel", this.state.emissaoDavDisponivel);
      form.append("congelamento_preco_ativo", this.state.congelamentoPrecoAtivo);

      formEndereco = {
        rua: this.state.form.endereco.rua,
        numero: this.state.form.endereco.numero,
        bairro: this.state.form.endereco.bairro,
        cidade: this.state.form.endereco.cidade,
        estado: this.state.form.endereco.estado,
        pais: this.state.form.endereco.pais,
        latitude: this.state.form.endereco.latitude,
        longitude: this.state.form.endereco.longitude,
        cep: this.state.form.endereco.cep,
      };

      formUsuario = {
        email: this.state.form.usuario.email,
        senha: this.state.form.usuario.senha,
        tipo: "estabelecimento",
      };

      try {
        const response = await CadastrarEstabelecimento(form, formEndereco, formUsuario);
        if (response) {
          this.limparForm();
          await this.getEstabelecimentos(1);
          await this.ListarTiposEstabelecimento();
          this.handleShowAlert("Estabelecimento cadastrado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert(error.error, "error");
      }
    } else {
      this.setState({ errorCadastro: "Informações obrigatórias (*) faltando" });
      this.goTop();
    }
  };

  ListarTiposEstabelecimento = async () => {
    const tipos = await ListarTipoEstabelecimento();
    tipos.forEach((t) => {
      t.label = t.nome;
      t.value = t._id;
    });
    this.setState({ tiposEstabelecimento: tipos });
  };

  receberDadosTabela = (tipo, dados) => {
    if (tipo === "editar") {
      this.preencherFormEdit(dados);
      this.setState({ edited: false });
      this.atualizarMapa(this.state.form.endereco);
    } else if (tipo === "deletar") {
      this.setState({ estabelecimentoSelecionado: dados });
      this.handleShowModalAlert();
    } else {
      return;
    }
  };

  async componentDidMount() {
    await this.ListarTiposEstabelecimento();
    await this.getEstabelecimentos();
  }

  componentDidUpdate = () => {
    this.atualizarMapa(this.state.form.endereco);
    if (this.mapRef.current) {
      this.mapRef.current.leafletElement.invalidateSize();
    }
  };

  handleMapClick = (e) => {
    this.setState({
      hasLocation: true,
      form: {
        ...this.state.form,
        endereco: {
          ...this.state.form.endereco,
          latitude: e.latlng.lat,
          longitude: e.latlng.lng,
        },
      },
    });
  };

  render() {
    const marker = this.state.hasLocation ? (
      <Marker
        position={[this.state.form.endereco.latitude, this.state.form.endereco.longitude]}
      >
        <Popup>You are here</Popup>
      </Marker>
    ) : null;

    return (
      <div style={{ margin: 10, marginLeft: 50, marginRight: 50 }}>
        <br></br>
        <Row>
          <Col md={9}>
            <h3>Estabelecimentos</h3>
          </Col>
          <Col>
            <Button
              onClick={() => {
                this.handleShowModalEstabelecimento();
              }}
            >
              Cadastrar estabelecimento
            </Button>
          </Col>
        </Row>
        <br></br>
        <FormControl
          placeholder="Pesquisar Estabelecimento"
          onChange={(e) => this.pesquisarEstabelecimento(e.target.value)}
        />
        <TBLEstabelecimento
          data={this.state.estabelecimentos}
          dataCallback={this.receberDadosTabela}
          getEstabelecimentos={() => this.getEstabelecimentos()}
          limit={this.state.limit}
          pages={this.state.pages}
          loading={this.state.loading}
          changePage={(p) => this.getEstabelecimentos(p)}
        ></TBLEstabelecimento>
        <Modal
          id="modal-estabelecimento"
          size="xl"
          show={this.state.showModalEstabelecimento}
          onHide={this.handleCloseModalEstabelecimento}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.modoEditarEstabelecimento
                ? "Estabelecimento"
                : "Cadastrar estabelecimento"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ display: "flex", flexDirection: "row" }}>
              {this.state.modoEditarEstabelecimento ? (
                <div
                  style={{
                    width: "75%",
                    textAlign: "center",
                    marginBottom: 20,
                  }}
                >
                  <Image
                    rounded
                    style={{ width: 60, height: 60 }}
                    src={api_url_estabelecimentos_image + this.state.foto_estabelecimento}
                  ></Image>
                </div>
              ) : null}
              {this.state.errorCadastro ? (
                <div>
                  <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
                </div>
              ) : null}
              {this.state.estabelecimentoSelecionado && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    float: "right",
                  }}
                >
                  <Form inline>
                    <FormLabel style={{ color: "#701B8C" }}>
                      {this.state.statusAtualEstabelecimentoSelecionado
                        ? "Aberto"
                        : "Fechado"}
                    </FormLabel>
                    <Switch
                      checked={this.state.statusAtualEstabelecimentoSelecionado}
                      onChange={(e) => this.mudarStatus(e.target.checked)}
                    />
                  </Form>
                  {this.state.modoVisualizarEstabelecimento &&
                  this.state.modoEditarEstabelecimento ? (
                    <Button
                      variant="primary"
                      style={{
                        float: "right",
                        height: 40,
                        marginTop: 20,
                        marginLeft: 20,
                      }}
                      onClick={() => {
                        this.setState({ modoVisualizarEstabelecimento: false });
                      }}
                    >
                      EDITAR
                    </Button>
                  ) : null}
                </div>
              )}
            </div>
            <Form>
              <div>
                <h5>Informações gerais</h5>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Tipo *</Form.Label>
                      <Select
                        isDisabled={this.state.modoVisualizarEstabelecimento}
                        value={this.state.form.tipo}
                        onChange={(opt) => {
                          this.setState({
                            form: { ...this.state.form, tipo: opt },
                          });
                        }}
                        options={this.state.tiposEstabelecimento}
                        placeholder="Tipo"
                      />
                      {this.state.error.tipo ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.tipo}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Nome Social *</Form.Label>
                      <Form.Control
                        value={this.state.form.nome_social}
                        disabled={this.state.modoVisualizarEstabelecimento}
                        type="text"
                        placeholder="Nome Social"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              nome_social: e.target.value,
                            },
                          });
                        }}
                      />
                      {this.state.error.nome_social ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.nome_social}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Nome Fantasia *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEstabelecimento}
                        value={this.state.form.nome_fantasia}
                        type="text"
                        placeholder="Nome Fantasia"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              nome_fantasia: e.target.value,
                            },
                          });
                        }}
                      />
                      {this.state.error.nome_fantasia ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.nome_fantasia}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>CNPJ *</Form.Label>
                      <InputMask
                        disabled={this.state.modoVisualizarEstabelecimento}
                        mask="99.999.999/9999-99"
                        class="form-control"
                        value={this.state.form.cnpj}
                        type="text"
                        placeholder="CNPJ"
                        onChange={(e) => {
                          this.setState({
                            form: { ...this.state.form, cnpj: e.target.value },
                          });
                          const res = ValidarCNPJ(e.target.value);

                          this.setState({ validarCNPJ: res });
                        }}
                      />
                      {this.state.error.cnpj ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.cnpj}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Telefone *</Form.Label>
                      <InputMask
                        disabled={this.state.modoVisualizarEstabelecimento}
                        mask="(99) 99999-9999"
                        class="form-control"
                        value={this.state.form.telefone}
                        type="text"
                        placeholder="Telefone"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              telefone: e.target.value,
                            },
                          });
                        }}
                      />
                      {this.state.error.telefone ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.telefone}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Inscrição Estadual</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEstabelecimento}
                        value={this.state.form.inscricao_estadual}
                        type="text"
                        placeholder="Inscrição Estadual"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              inscricao_estadual: e.target.value,
                            },
                          });
                        }}
                      />
                      {this.state.error.inscricao_estadual ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.error.inscricao_estadual}
                          </p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Area de atuação</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEstabelecimento}
                        value={this.state.form.area_atuacao}
                        type="text"
                        placeholder="Area de atuação"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              area_atuacao: e.target.value,
                            },
                          });
                        }}
                      />
                      {this.state.error.area_atuacao ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.area_atuacao}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group>
                  <Form.Label>Imagem *</Form.Label>
                  <input
                    style={{ padding: 3 }}
                    disabled={this.state.modoVisualizarEstabelecimento}
                    className={"form-control"}
                    type="file"
                    accept="image/x-png,image/gif,image/jpeg"
                    ref={(ref) => (this.fileInput = ref)}
                    onChange={this.fileChangedHandler}
                  ></input>
                  {this.state.error.imagem ? (
                    <div>
                      <p style={{ color: "red" }}>{this.state.error.imagem}</p>
                    </div>
                  ) : null}
                </Form.Group>
              </div>
              <div>
                <h5>Endereço</h5>
                <Form.Group>
                  <Form.Label>Digite o CEP *</Form.Label>
                  <Form.Control
                    disabled={this.state.modoVisualizarEstabelecimento}
                    value={this.state.form.endereco.cep}
                    type="text"
                    placeholder="CEP"
                    onChange={(e) => {
                      this.setState({
                        form: {
                          ...this.state.form,
                          endereco: {
                            ...this.state.form.endereco,
                            cep: e.target.value,
                          },
                        },
                      });
                      const res = ValidarCep(e.target.value);
                      this.setState({ validarCep: res });
                    }}
                    onBlur={() => {
                      if (this.state.validarCep) {
                        this.pesquisarCEP(this.state.form.endereco.cep);
                        this.setState({ edited: false });
                        this.atualizarMapa(this.state.form.endereco);
                      }
                    }}
                  />
                  {this.state.error.endereco.cep ? (
                    <div>
                      <p style={{ color: "red" }}>{this.state.error.endereco.cep}</p>
                    </div>
                  ) : null}
                </Form.Group>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Cidade *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEstabelecimento}
                        value={this.state.form.endereco.cidade}
                        type="text"
                        placeholder="Cidade"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              endereco: {
                                ...this.state.form.endereco,
                                cidade: e.target.value,
                              },
                            },
                          });
                        }}
                        onBlur={() => {
                          this.setState({ edited: false });
                          this.atualizarMapa(this.state.form.endereco);
                        }}
                      />
                      {this.state.error.endereco.cidade ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.error.endereco.cidade}
                          </p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Bairro *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEstabelecimento}
                        value={this.state.form.endereco.bairro}
                        type="text"
                        placeholder="Bairro"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              endereco: {
                                ...this.state.form.endereco,
                                bairro: e.target.value,
                              },
                            },
                          });
                        }}
                      />
                      {this.state.error.endereco.bairro ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.error.endereco.bairro}
                          </p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Rua *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEstabelecimento}
                        value={this.state.form.endereco.rua}
                        type="text"
                        placeholder="Rua"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              endereco: {
                                ...this.state.form.endereco,
                                rua: e.target.value,
                              },
                            },
                          });
                        }}
                        onBlur={() => {
                          this.setState({ edited: false });
                          this.atualizarMapa(this.state.form.endereco);
                        }}
                      />
                      {this.state.error.endereco.rua ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.endereco.rua}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Número *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEstabelecimento}
                        value={this.state.form.endereco.numero}
                        type="text"
                        placeholder="Número"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              endereco: {
                                ...this.state.form.endereco,
                                numero: e.target.value,
                              },
                            },
                          });
                        }}
                        onBlur={() => {
                          this.setState({ edited: false });
                          this.atualizarMapa(this.state.form.endereco);
                        }}
                      />
                      {this.state.error.endereco.numero ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.error.endereco.numero}
                          </p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <div>
                <h5>Selecione o local do estabelecimento no mapa</h5>
                <Row>
                  <Col>
                    <Map
                      ref={this.mapRef}
                      center={this.state.center}
                      zoom={this.state.zoom}
                      onClick={
                        this.state.modoVisualizarEstabelecimento
                          ? null
                          : this.handleMapClick
                      }
                      style={{
                        width: "100%",
                        height: "30vh",
                        marginTop: 10,
                      }}
                    >
                      <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
                      />
                      {marker}
                    </Map>
                  </Col>
                </Row>
              </div>
              <br></br>
              <Row>
                <Col>
                  <div>
                    <h5>Informações de Autenticação</h5>
                    <Row>
                      <Col>
                        <Form.Group>
                          <Form.Label>Email *</Form.Label>
                          <Form.Control
                            disabled={this.state.modoVisualizarEstabelecimento}
                            value={this.state.form.usuario.email}
                            type="email"
                            placeholder="Email"
                            onChange={(e) => {
                              this.setState({
                                form: {
                                  ...this.state.form,
                                  usuario: {
                                    ...this.state.form.usuario,
                                    email: e.target.value,
                                  },
                                },
                              });
                            }}
                          />
                          {this.state.error.usuario.email ? (
                            <div>
                              <p style={{ color: "red" }}>
                                {this.state.error.usuario.email}
                              </p>
                            </div>
                          ) : null}
                        </Form.Group>
                      </Col>
                      <Col>
                        {this.state.modoVisualizarEstabelecimento ? (
                          <div style={{ width: 400, margin: "auto" }}>
                            <Button
                              variant="primary"
                              style={{ marginTop: 30, width: 400 }}
                              onClick={() => {
                                this.handleShowModalSenha();
                              }}
                            >
                              Alterar senha
                            </Button>
                          </div>
                        ) : this.state.modoEditarEstabelecimento ? (
                          <div style={{ width: 400, margin: "auto" }}>
                            <Button
                              variant="primary"
                              style={{ marginTop: 30, width: 400 }}
                              onClick={() => {
                                this.handleShowModalSenha();
                              }}
                            >
                              Alterar senha
                            </Button>
                          </div>
                        ) : (
                          <Form.Group>
                            <Form.Label>Senha *</Form.Label>
                            <Form.Control
                              disabled={this.state.modoVisualizarEstabelecimento}
                              value={this.state.form.usuario.senha}
                              type="password"
                              placeholder="Senha"
                              onChange={(e) => {
                                this.setState({
                                  form: {
                                    ...this.state.form,
                                    usuario: {
                                      ...this.state.form.usuario,
                                      senha: e.target.value,
                                    },
                                  },
                                });
                              }}
                            />
                            {this.state.error.usuario.senha ? (
                              <div>
                                <p style={{ color: "red" }}>
                                  {this.state.error.usuario.senha}
                                </p>
                              </div>
                            ) : null}
                          </Form.Group>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <br></br>
              <Row>
                <Col>
                  <div>
                    <h5>Configuração de Entrega e Taxa de Serviço</h5>
                    <div
                      style={{
                        marginBottom: 15,
                      }}
                    >
                      <Form inline>
                        <FormLabel style={{ color: "#701B8C" }}>
                          Entrega Própria
                        </FormLabel>
                        <Switch
                          checked={this.state.statusEntregaEstabelecimento}
                          onChange={(e) => this.mudarStatusEntrega(e.target.checked)}
                        />
                        <FormLabel style={{ color: "#701B8C" }}>Entrega iFeira</FormLabel>
                        <Switch
                          checked={!this.state.statusEntregaEstabelecimento}
                          onChange={(e) => this.mudarStatusEntrega(!e.target.checked)}
                        />
                      </Form>
                    </div>
                    <Row>
                      <Col>
                        <Form.Group>
                          <Form.Label>
                            Percentual para calculo da taxa de serviço
                          </Form.Label>
                          <Form.Control
                            disabled={this.state.modoVisualizarEstabelecimento}
                            value={this.state.porcentagemTaxaServico}
                            type="number"
                            min={0}
                            max={1}
                            placeholder="0,00"
                            onChange={(e) => {
                              const value = parseFloat(e.target.value);
                              if (value < 0 || value > 1) return;
                              this.setState({ porcentagemTaxaServico: value });
                            }}
                          />
                          <Form.Text>Ex: 0,2 equivale a 20%</Form.Text>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group>
                          <Form.Label>Valor mínimo do pedido</Form.Label>
                          <Form.Control
                            disabled={this.state.modoVisualizarEstabelecimento}
                            value={this.state.valorPedidoMinimo}
                            type="number"
                            min={0}
                            placeholder="R$ 0,00"
                            onChange={(e) => {
                              const value = parseFloat(e.target.value);
                              this.setState({ valorPedidoMinimo: value });
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <br></br>
              <Row>
                <Col>
                  <div>
                    <h5>Configuração de Destaque e Modelo</h5>
                    <Row>
                      <Col>
                        <Form inline>
                          <FormLabel style={{ color: "#701B8C" }}>
                            Estabelecimento Destaque
                          </FormLabel>
                          <Switch
                            checked={this.state.statusEstabelecimentoDestaque}
                            onChange={(e) => this.mudarStatusDestaque(e.target.checked)}
                          />
                          <Form.Text>
                            Indica se o estabelecimento aparecerá na home do app caso
                            nenhuma localização seja informada pelo usuário
                          </Form.Text>
                        </Form>
                      </Col>
                      <Col>
                        <Form inline>
                          <FormLabel style={{ color: "#701B8C" }}>
                            Estabelecimento Modelo
                          </FormLabel>
                          <Switch
                            checked={this.state.statusEstabelecimentoModelo}
                            onChange={(e) =>
                              this.mudarStatusEstabelecimentoModelo(e.target.checked)
                            }
                          />
                          <Form.Text>
                            Indica se o estabelecimento é modelo para clonagem de novos
                            estabelecimentos
                          </Form.Text>
                        </Form>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <br></br>
              <Row>
                <Col>
                  <div>
                    <h5>Configuração de Integração</h5>
                    <Row>
                      <Col>
                        <Form inline>
                          <FormLabel style={{ color: "#701B8C" }}>
                            Congelar preço dos itens do pedido
                          </FormLabel>
                          <Switch
                            disabled={this.state.modoVisualizarEstabelecimento}
                            checked={this.state.congelamentoPrecoAtivo}
                            onChange={(e) =>
                              this.setState({ congelamentoPrecoAtivo: e.target.checked })
                            }
                          />
                          <Form.Text>
                            Indica se o preço de promoção dos itens serão congelados, ou
                            seja, não mudarão coforme a data de agendamento do pedido
                          </Form.Text>
                        </Form>
                      </Col>
                      <Col>
                        <Form inline>
                          <FormLabel style={{ color: "#701B8C" }}>
                            Emissão de DAV (Orçamento)
                          </FormLabel>
                          <Switch
                            disabled={this.state.modoVisualizarEstabelecimento}
                            checked={this.state.emissaoDavDisponivel}
                            onChange={(e) =>
                              this.setState({ emissaoDavDisponivel: e.target.checked })
                            }
                          />
                          <Form.Text>
                            Se o ERP permitir gerar DAV, essa opção criará o DAV no
                            sistema após separação do pedido
                          </Form.Text>
                        </Form>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalEstabelecimento();
              }}
            >
              Fechar
            </Button>
            {this.state.modoEditarEstabelecimento ? (
              <Button
                disabled={this.state.modoVisualizarEstabelecimento}
                variant="primary"
                onClick={() => {
                  this.editarEstabelecimento();
                }}
              >
                {"Editar"}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.cadastrarEstabelecimento();
                }}
              >
                {"Cadastrar"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.showModalAlert}
          onHide={this.handleCloseModalAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Deseja realmente excluir o estabelecimento?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.deletarEstabelecimento();
              }}
            >
              Sim
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="md"
          show={this.state.showModalSenha}
          onHide={() => {
            this.setState({
              errorCadastro: "",
              error: {
                ...this.state.error,
                usuario: { ...this.state.error.usuario, senha: "" },
              },
            });
            this.handleCloseModalSenha();
          }}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>Nova senha</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorSenha === "Senha atualizada com sucesso" ? (
              <div>
                <p style={{ color: "green" }}>{this.state.errorSenha}</p>
              </div>
            ) : (
              <div>
                <p style={{ color: "red" }}>{this.state.errorSenha}</p>
              </div>
            )}
            <Form.Group>
              <Form.Label>Senha *</Form.Label>
              <Form.Control
                value={this.state.form.usuario.senha}
                type="password"
                placeholder="Senha"
                onChange={(e) => {
                  this.setState({
                    form: {
                      ...this.state.form,
                      usuario: {
                        ...this.state.form.usuario,
                        senha: e.target.value,
                      },
                    },
                  });
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Confirmar senha *</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirmar senha"
                onChange={(e) => {
                  this.setState({ confirmaSenha: e.target.value });
                }}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalSenha();
              }}
            >
              Fechar
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.confirmaSenha();
              }}
            >
              Salvar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
